import { PaginationState } from "@tanstack/react-table";
import { format, isValid, parseISO } from "date-fns";
import { Field, Form, Formik, FormikErrors } from "formik";
import { nanoid } from "nanoid";
import { useEffect, useRef, useState } from "react";
import { useBlocker, useNavigate, useParams } from "react-router-dom";
import * as Yup from "yup";
import { EmptyListPlaceholderContent } from "../../shared/Ui/EmptyPageBlock";
import SelectCustomFormik from "../../shared/Ui/SelectCustom/SelectCustomFormik";
import Pagination from "../../shared/components/Table/Pagination";
import style from "./index.module.css";
import InputMask from "react-input-mask";
import AlertBox from "../../shared/Ui/AlertBox/AlertBox";
import ModalButton from "../../shared/Ui/Buttons/ModalButtons";
import Loader from "../../shared/Ui/Loader/Loader";
import ModalComponent from "../../shared/Ui/ModalComponent/ModalWindow";
import { useAppDispatch, useAppSelector } from "../../shared/hook";
import { useTranslation } from "react-i18next";
import { clearBlocker, setBlocker } from "../../shared/slice/blockerSlice";
import { SkeletonTheme } from "react-loading-skeleton";
import MockSkeleton from "./utils/MockSkeleton";
import ActionDropwdownCell from "../../shared/components/Table/ActionDropwdownCell";
import { Tooltip } from "react-tooltip";
import { deleteUser, getUserList, registerUser, RegistrationRequest, updateUser } from "../../common/api/userCreateApi";
import { FaExclamationCircle } from "react-icons/fa";
import StatusBadge from "../../shared/Ui/StatusBadge/StatusBadge";
import PageNotRole from "../../shared/Ui/PageNotFound/PageNotRole";


function RegistrationUsers() {
    const roleUser = useAppSelector((state) => state.auth.userData.role[0]);
    const [role, setRole] = useState<any>(null);
    const dispatch = useAppDispatch();
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);
    const { orderId } = useParams();
    const [alertOpen, setAlertOpen] = useState<any>(null);
    const [isFormChanged, setIsFormChanged] = useState(false);
    const [isOpen1, setIsOpen1] = useState(true);
    const [isOpen2, setIsOpen2] = useState(false);
    const [userDelete, setUserDelete] = useState<any>(null);
    const [sort, setSort] = useState<"ASC" | "DESC">("DESC");
    const [errorModal, setErrorModal] = useState<any>(null);
    const [isLoading, setIsLoading] = useState(false);
    const [userEditModal, setUserEditModal] = useState<any>(null
    );

    const [activeTooltipId, setActiveTooltipId] = useState<number | null>(null);
    const pageSize = useAppSelector((state) => state.userSettings.pageSize);
    const [pagination, setPagination] = useState<PaginationState>({
        pageIndex: 0,
        pageSize: 10,
    });
    const [userData, setUserData] = useState<any>([]);
    const [initialValues, setInitialValues] = useState<any>({
        firstname: "",
        lastname: "",
        email: "",
        password: "",
        phone: "",
        role: "",
    });



    const formValidationSchema = (isPasswordRequired: boolean) =>
        Yup.object().shape({
            firstname: Yup.string()
                .required("Поле обязательно для заполнения")
                .min(2, "Минимум 2 символа")
                .max(50, "Максимум 50 символов"),
            lastname: Yup.string()
                .required("Поле обязательно для заполнения")
                .min(2, "Минимум 2 символа")
                .max(50, "Максимум 50 символов"),
            email: Yup.string()
                .email("Некорректный адрес электронной почты")
                .required("Поле обязательно для заполнения"),
            password: Yup.string().when([], (password, schema) => {
                return isPasswordRequired
                    ? schema.required("Поле обязательно для заполнения").min(3, "Поле должно содержать от 3 до 10 символов").max(10, "Поле должно содержать от 3 до 10 символов")
                    : schema.notRequired();
            }),
            phone: Yup.string()
                .required("Поле обязательно для заполнения"),
            role: Yup.string()
                .required("Поле обязательно для заполнения"),
        });



    const roleDictionary: { [key: string]: any} = {
        ROLE_ADMIN: 'Админ',
        ROLE_USER: 'Оператор'
    };

    const fetchUsers = async () => {
        try {
            const data = await getUserList(); // передаем параметры страницы
            console.log("data user", data);

            setUserData(data.users);

        } catch (error) {
            console.error("Ошибка при получении списка пользователей:", error);
        }
    };

    useEffect(() => {
        fetchUsers();
    }, [orderId, pagination]);


    const toggleSort = () => {
        const newSortDirection = sort === "ASC" ? "DESC" : "ASC";
        setSort(newSortDirection);
    };


    const handleTooltipToggle = (id: number) => {
        setActiveTooltipId((prevId) => (prevId === id ? null : id));
    };


    const calculateItemNumber = (index: any) => {
        return pagination.pageIndex * pagination.pageSize + index + 1;
    };

    // Это главный запрос ВНИМАНИЕ!
    async function submitCreate(formikValues: any, resetForm: any) {

        const backendData: RegistrationRequest = {
            firstname: formikValues.firstname,
            lastname: formikValues.lastname,
            email: formikValues.email,
            phone: formikValues.phone,
            password: formikValues.password,
            role: formikValues.role,
        };


        try {
            // Отправляем данные на бэкенд
            registerUser(backendData)
                .then((res) => {
                    setAlertOpen({
                        status: "SUCCESS",
                        message: "Пользователь успешно создан",
                    })

                    resetForm();
                    fetchUsers()
                })
        } catch (error: any) {
            setAlertOpen({
                status: "error",
                message: error.response.data.message,
            });
        }
    }

    // Это главный запрос ВНИМАНИЕ!
    async function submitEdit(formikValues: any) {

        const backendData: RegistrationRequest = {
            firstname: formikValues.firstname !== userEditModal.firstname ? formikValues.firstname : null,
            lastname: formikValues.lastname !== userEditModal.lastname ? formikValues.lastname : null,
            email: formikValues.email !== userEditModal.email ? formikValues.email : null,
            phone: formikValues.phone !== userEditModal.phone ? formikValues.phone : null,
            password: formikValues.password || null,
            role: formikValues.role !== userEditModal.role ? formikValues.role : null,
        };

        try {
            // Отправляем данные на бэкенд
            updateUser(formikValues.userId, backendData)
                .then((res) => {
                    setAlertOpen({
                        status: "SUCCESS",
                        message: "Пользователь отредактирован",
                    })
                })
        } catch (error: any) {
            setAlertOpen({
                status: "error",
                message: error.message,
            });
        }
        setUserEditModal(null)
        fetchUsers()
    }

    // Это БОКИРУЕМ ПОКИДАНИЕ СТРАНИЦЫ ЕСЛИ ЕСТЬ ИЗМЕНЕНИЯ!
    useEffect(() => {
        const handleBeforeUnload = (event: any) => {
            // Проверяем состояние кнопки "Сохранить"
            if (isFormChanged) {
                event.preventDefault();
                event.returnValue = t("notifications.unsaved_data");
            }
        };

        window.addEventListener("beforeunload", handleBeforeUnload);
        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    }, [isFormChanged]);


    const { isBlocked, proceed } = useAppSelector((state) => state.blocker);

    let blocker = useBlocker(
        ({ currentLocation, nextLocation }) =>
            isBlocked !== false && 

            currentLocation.pathname !== nextLocation.pathname,
    );

    //   if (loading && !role) return <Loader/>;

    if (roleUser !== "ROLE_ADMIN") { 
        return (
            <PageNotRole />
        )
    }

    return (
        <div className="flex flex-col w-full">
            <Formik
                initialValues={initialValues}
                onSubmit={(formikValues, { resetForm }) => submitCreate(formikValues, resetForm)}
                enableReinitialize={true}
                validateOnBlur={true}
                validateOnChange={true}
                validationSchema={formValidationSchema(true)}
            >
                {(formik) => {
                    const totalProductsCount = formik.values.orderProducts?.length;
                    // const totalAmount = formik.values.orderProducts.reduce(
                    //     (acc:any, current:any) => acc + Number(current.amount || 0),
                    //     0,
                    // );
                    return (
                        <Form 
                        className={`w-full mt-[20px] ${roleUser === 'ROLE_ADMIN' ? '' : 'hidden'}`}>
                            {isBlocked && blocker.state === "blocked" ? (
                                <ModalComponent
                                    isOpen={true}
                                    onClose={() => {
                                        if (blocker && typeof blocker.reset === "function") {
                                            blocker.reset();
                                        } else {
                                            console.error("Reset function is not available.");
                                        }
                                    }}
                                    headerContent={
                                        <>
                                            <span>{t("notifications.modal_notification")}</span>
                                            <button
                                                type="button"
                                                onClick={() => {
                                                    if (blocker && typeof blocker.reset === "function") {
                                                        blocker.reset();
                                                    } else {
                                                        console.error("Reset function is not available.");
                                                    }
                                                }}
                                                aria-label="Close"
                                                className="float-right cursor-pointer bg-none border-none"
                                            >
                                                &times;
                                            </button>
                                        </>
                                    }
                                    content={<p>{t("notifications.unsaved_data")}</p>}
                                    customContent={
                                        <>
                                            <ModalButton
                                                type="button"
                                                onClick={() => {
                                                    dispatch(clearBlocker());
                                                    if (blocker && typeof blocker.proceed === "function") {
                                                        blocker.proceed();
                                                    } else {
                                                        console.error("Proceed function is not available.");
                                                    }
                                                }}
                                            >
                                                {t("mainButtons.cancel")}
                                            </ModalButton>
                                            <ModalButton
                                                type="button"
                                                color="green"
                                                onClick={async () => {
                                                    dispatch(clearBlocker());
                                                    try {
                                                        await submitCreate(formik.values, formik.resetForm);
                                                        if (blocker && typeof blocker.proceed === "function") {
                                                            blocker.proceed();
                                                        }
                                                    } catch (error) {
                                                        console.error("Error saving data:", error);
                                                    }
                                                }}
                                            >
                                                {t("mainButtons.save")}
                                            </ModalButton>
                                        </>
                                    }
                                />
                            ) : null}
                            <ModalComponent
                                isOpen={errorModal}
                                onClose={() => setErrorModal(null)}
                                headerContent={t("notifications.modal_notification")}
                                content={
                                    <p>
                                        {`${t("errors.errors_list")}: ${errorModal?.errorMessage ? errorModal?.errorMessage : "ошибка."}`}
                                    </p>
                                }
                                customContent={
                                    <ModalButton type="button" onClick={() => setErrorModal(null)}>
                                        {t("mainButtons.accept")}
                                    </ModalButton>
                                }
                            />
                            <ModalComponent
                                isOpen={userDelete !== null}
                                onClose={() => setUserDelete(null)}
                                headerContent={t("notifications.modal_notification")}
                                content={
                                    <p>
                                        {`Вы уверены что хотите удалить пользователя ${userDelete?.email}`}
                                    </p>
                                }
                                customContent={
                                    <>
                                        <ModalButton type="button" onClick={() => setUserDelete(null)}>
                                            {t("mainButtons.cancel")}
                                        </ModalButton>
                                        <ModalButton color="green" type="button" onClick={async () => {
                                            await deleteUser(userDelete?.userId); // Функция для удаления пользователя
                                            await fetchUsers();
                                            setUserDelete(null)
                                        }}>
                                            {t("mainButtons.accept")}
                                        </ModalButton>
                                    </>
                                }
                            />

                            <div className="flex flex-col bg-white my-5 p-5 pt-8 relative rounded-xl shadow-md gap-[20px] overflow-visible">
                                <div
                                    className="flex items-center text-base text-gray-600 font-light gap-x-[10px] cursor-pointer pb-[20px] border-b-[2px]"
                                    onClick={() => setIsOpen1(!isOpen1)}
                                >
                                    <img src={"/icons/user-plus.svg"} className="w-[20px]" alt="icon" />
                                    <div className="uppercase">{t("users.create_user")}</div>
                                    <div className={`ml-auto transform transition-transform duration-300 ${isOpen1 ? "rotate-180" : "rotate-0"}`}>
                                        <svg
                                            className="w-6 h-6"
                                            fill="none"
                                            stroke="currentColor"
                                            viewBox="0 0 24 24"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
                                        </svg>
                                    </div>
                                </div>

                                <div className={`flex gap-[20px] flex-wrap ${isOpen1 ? "hidden" : ""}`}>
                                    <div className={style.inputField1}>
                                        <div className={style.labelAndButtonWrapper}>
                                            <label className={style.inputLabel}>
                                                {t("users.name")}*
                                            </label>
                                            {formik.touched.firstname &&
                                                formik.errors.firstname && (
                                                    <div className={style.tooltipWrapper}>
                                                        <FaExclamationCircle className={style.errorIcon} />
                                                        <div className={style.tooltipText}>
                                                            {typeof formik.errors.firstname ===
                                                                "string"
                                                                ? formik.errors.firstname
                                                                : t(
                                                                    "errors.error",
                                                                )}
                                                        </div>
                                                    </div>
                                                )}
                                        </div>
                                        <Field
                                            type="text"
                                            name="firstname"
                                            placeholder={t("users.choose_name")}
                                            className={style.placeholder}
                                            onChange={(e: any) => {
                                                formik.handleChange(e);
                                                dispatch(setBlocker(true));
                                                setIsFormChanged(true);
                                            }}
                                        />
                                    </div>

                                    <div className={style.inputField1}>
                                        <div className={style.labelAndButtonWrapper}>
                                            <label className={style.inputLabel}>
                                                {t("users.surname")}
                                            </label>
                                            {formik.touched.lastname &&
                                                formik.errors.lastname && (
                                                    <div className={style.tooltipWrapper}>
                                                        <FaExclamationCircle className={style.errorIcon} />
                                                        <div className={style.tooltipText}>
                                                            {typeof formik.errors.lastname ===
                                                                "string"
                                                                ? formik.errors.lastname
                                                                : t(
                                                                    "errors.error",
                                                                )}
                                                        </div>
                                                    </div>
                                                )}
                                        </div>
                                        <Field
                                            type="text"
                                            name="lastname"
                                            placeholder={t("users.choose_surname")}
                                            className={style.placeholder}
                                            onChange={(e: any) => {
                                                formik.handleChange(e);
                                                dispatch(setBlocker(true));
                                                setIsFormChanged(true);
                                            }}
                                        />
                                    </div>

                                    <div className={style.inputField1}>
                                        <div className={style.labelAndButtonWrapper}>
                                            <label className={style.inputLabel}>
                                                {t("users.email")}
                                            </label>
                                            {formik.touched.email &&
                                                formik.errors.email && (
                                                    <div className={style.tooltipWrapper}>
                                                        <FaExclamationCircle className={style.errorIcon} />
                                                        <div className={style.tooltipText}>
                                                            {typeof formik.errors.email ===
                                                                "string"
                                                                ? formik.errors.email
                                                                : t(
                                                                    "errors.error",
                                                                )}
                                                        </div>
                                                    </div>
                                                )}
                                        </div>
                                        <Field
                                            type="email"
                                            name="email"
                                            placeholder={t("users.choose_email")}
                                            className={style.placeholder}
                                            onChange={(e: any) => {
                                                formik.handleChange(e);
                                                dispatch(setBlocker(true));
                                                setIsFormChanged(true);
                                            }}
                                        />
                                    </div>

                                    <div className={style.inputField1}>
                                        <div className={style.labelAndButtonWrapper}>
                                            <label className={style.inputLabel}>
                                                {t("users.password")}
                                            </label>
                                            {formik.touched.password &&
                                                formik.errors.password && (
                                                    <div className={style.tooltipWrapper}>
                                                        <FaExclamationCircle className={style.errorIcon} />
                                                        <div className={style.tooltipText}>
                                                            {typeof formik.errors.password ===
                                                                "string"
                                                                ? formik.errors.password
                                                                : t(
                                                                    "errors.error",
                                                                )}
                                                        </div>
                                                    </div>
                                                )}
                                        </div>
                                        <div className="relative flex items-center">
                                            <Field
                                                type={showPassword ? "text" : "password"}
                                                min={1}
                                                max={10}
                                                name="password"
                                                placeholder="users.choose_password"
                                                maxLength={10}
                                                className="placeholder" // Ваш класс для стилей
                                                onChange={(e: any) => {
                                                    formik.handleChange(e);
                                                    dispatch(setBlocker(true));
                                                    setIsFormChanged(true);
                                                }}
                                            />

                                            <button
                                                type="button"
                                                onClick={() => setShowPassword(prev => !prev)}
                                                className="absolute right-2" // Позиционирование кнопки
                                            >
                                                {!showPassword ? (
                                                    <img
                                                        src="/icons/visible_eye.svg"
                                                        alt="Скрыть пароль" // Добавлено свойство alt для доступности
                                                        className="block h-[20px] w-[20px] duration-200 group-hover:brightness-200 group-hover:invert-1"
                                                    />
                                                ) : (
                                                    <img
                                                        src="/icons/dis_eye.svg"
                                                        alt="Показать пароль"
                                                        className="block h-[20px] w-[20px] duration-200 group-hover:brightness-200 group-hover:invert-1"
                                                    />

                                                )}
                                            </button>
                                        </div>
                                    </div>

                                    <div className={style.inputField1}>
                                        <div className={style.labelAndButtonWrapper}>
                                            <label className={style.inputLabel}>
                                                {t("users.phone")}
                                            </label>
                                            {formik.touched.phone &&
                                                formik.errors.phone && (
                                                    <div className={style.tooltipWrapper}>
                                                        <FaExclamationCircle className={style.errorIcon} />
                                                        <div className={style.tooltipText}>
                                                            {typeof formik.errors.phone ===
                                                                "string"
                                                                ? formik.errors.phone
                                                                : t(
                                                                    "errors.error",
                                                                )}
                                                        </div>
                                                    </div>
                                                )}
                                        </div>
                                        <InputMask
                                            mask="+7 (999) 999-99-99"
                                            maskChar="_"
                                            type="text"
                                            name="phone"
                                            placeholder={t("users.choose_phone")}
                                            className={style.placeholder}
                                            value={formik.values.phone}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                        />
                                    </div>

                                    <div className={style.inputField1}>
                                        <div className={style.labelAndButtonWrapper}>
                                            <label className={style.inputLabel}>
                                                {t("users.role")}
                                            </label>
                                            {formik.touched.role &&
                                                formik.errors.role && (
                                                    <div className={style.tooltipWrapper}>
                                                        <FaExclamationCircle className={style.errorIcon} />
                                                        <div className={style.tooltipText}>
                                                            {typeof formik.errors.role ===
                                                                "string"
                                                                ? formik.errors.role
                                                                : t(
                                                                    "errors.error",
                                                                )}
                                                        </div>
                                                    </div>
                                                )}
                                        </div>
                                        <Field
                                            component={SelectCustomFormik}
                                            name="role"
                                            placeholder={t("users.choose_role")}
                                            options={[
                                                { value: 'ROLE_ADMIN', label: 'Админ' },
                                                { value: 'ROLE_USER', label: 'Оператор' },
                                            ]}
                                            isMulti={false}
                                        />
                                    </div>
                                    <div className="ml-auto flex gap-[10px]">
                                        <button
                                            type="button"
                                            className="bg-bg w-auto text-gray-500 font-semibold py-2 px-4 h-[40px] rounded hover:brightness-75  whitespace-nowrap"
                                            onClick={() => {
                                                formik.resetForm()
                                            }}
                                        >
                                            {t("Отменить")}
                                        </button>
                                        <button
                                            className="buttonEtrackc h-[40px] mb-[6px]  w-[200px] bg-mainColor hover:brightness-75 text-white font-bold py-2 px-4 rounded"
                                            type="submit"
                                        >
                                            {t("Создать")}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </Form>
                    );
                }}
            </Formik>


            <div className="flex flex-col bg-white  my-5 p-5  pt-8 relative rounded-xl shadow-md gap-[20px] overflow-visible">
                <div
                    className=" flex items-center text-base text-gray-600 font-light gap-x-[10px] cursor-pointer pb-[20px] border-b-[2px] "
                    onClick={() => setIsOpen2(!isOpen2)}
                >
                    <img src={"/icons/user.svg"} alt="icon" />
                    <div className="uppercase ">Список пользователей</div>
                    <div
                        className={`ml-auto transform transition-transform duration-300 ${isOpen2 ? "rotate-180" : "rotate-0"}`}
                    >
                        <svg
                            className="w-6 h-6"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M19 9l-7 7-7-7"
                            ></path>
                        </svg>
                    </div>
                </div>
                <div className={`rounded-lg overflow-x-auto bg-white ${isOpen2 ? "hidden" : "="}` }>
                    <table className="max-w-full w-full leading-normal">
                        <thead className="border-b-2 border-gray-300">
                            <tr>
                                <th
                                    className="px-5 py-3 text-center text-gray-600 font-semibold bg-white border-b border-gray-200"
                                    scope="col"
                                >
                                    № Id
                                </th>
                                <th
                                    className="px-5 py-3 text-center text-gray-600 font-semibold bg-white border-b border-gray-200"
                                    scope="col"
                                >
                                    ФИО
                                </th>
                                <th
                                    className="flex flex-row items-center justify-center px-5 py-3  text-center text-gray-600 font-semibold bg-white border-b border-gray-200"
                                    scope="col"
                                >
                                    Email
                                    <div className="flex flex-col">
                                        <button className="h-6 w-6" onClick={toggleSort}>
                                            <img
                                                src={`/icons/arrow${sort === "ASC" ? "Down2" : "-top"}.svg`}
                                                className={`block h-6 w-6  ${sort === "ASC" ? "text-red-500" : ""}`}
                                                alt={sort === "ASC" ? "Ascending" : "Descending"}
                                            />
                                        </button>
                                    </div>
                                </th>
                                <th
                                    className="px-5 py-3 text-center text-gray-600 font-semibold bg-white border-b border-gray-200 "
                                    scope="col"
                                >
                                    Номер
                                </th>
                                <th
                                    className="px-5 py-3 text-center text-gray-600 font-semibold bg-white border-b border-gray-200"
                                    scope="col"
                                >
                                    Роли
                                </th>
                                <th
                                    className="px-5 py-3 text-center text-gray-600 font-semibold bg-white border-b  border-gray-200"
                                    scope="col"
                                >
                                    Статус
                                </th>
                            </tr>
                        </thead>
                        {isLoading ? (
                            <SkeletonTheme baseColor="#ebebeb" highlightColor="#c9c9c9">
                                <tbody className="font-normal text-center">
                                    {new Array(10).fill(1).map((_, index) => (
                                        <MockSkeleton index={index} />
                                    ))}
                                </tbody>
                            </SkeletonTheme>
                        ) : userData.length === 0 || !userData?.values ? (
                            <tbody>
                                <tr>
                                    <td colSpan={8} className="text-center py-5">
                                        <div>
                                            <EmptyListPlaceholderContent
                                                title={t("Пользователей не найдено")}
                                            // description={t("orderList.noOrdersDescription")}
                                            />
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        ) : (
                            <tbody className="font-normal text-center">
                                {userData?.slice(
                                    pagination.pageIndex * pagination.pageSize,
                                    (pagination.pageIndex + 1) *
                                    pagination.pageSize,
                                ).map((value: any, index: any) => (
                                    <tr
                                        key={`tr-${index}-${value.id}`}
                                        className="cursor-pointer hover:bg-gray-100 "
                                        onClick={() => { }}
                                    >
                                        <td className="px-5 py-5 text-sm border-b border-gray-200 text-gray-600">
                                            {calculateItemNumber(index) || "-"}
                                        </td>
                                        <td className="px-5 py-5 text-sm  border-b border-gray-200 text-gray-600 cursor-pointer "
                                        >
                                            {`${value.lastname} ${value.firstname}` || "-"}
                                        </td>
                                        <td className="px-5 py-5 text-sm border-b border-gray-200 text-gray-600">
                                            {value.email || "-"}
                                        </td>
                                        <td className="px-5 py-5 text-sm border-b border-gray-200 text-gray-600 text-center w-[225px]">
                                            {value.phone || "-"}
                                        </td>
                                        <td className="px-5 py-5 text-sm border-b border-gray-200 text-gray-600 text-center">
                                            {roleDictionary[value.role[0] as string] || "-"}
                                        </td>
                                        <td className="px-5 py-5 text-sm border-b border-gray-200 text-gray-600 text-center w-[225px]">
                                            {value?.disabled != null ? (
                                                !value.disabled ? (
                                                    <div className="flex justify-center">
                                                        <StatusBadge type="active">
                                                            {t("statusTypes.active")}
                                                        </StatusBadge>
                                                    </div>
                                                ) : (
                                                    <>
                                                        <StatusBadge>
                                                            {t("statusTypes.not_active")}
                                                        </StatusBadge>
                                                    </>
                                                )
                                            ) : (
                                                "-"
                                            )}
                                        </td>

                                        <td className="px-5 py-5 text-sm border-b border-gray-200 text-gray-600"
                                            onClick={(e) => e.stopPropagation()}
                                        >
                                            <ActionDropwdownCell
                                                key={`cell-${index}-${value.email}-acitons`}
                                                id={value.email}
                                                actions={[
                                                            {
                                                                title: t("users.edit"),
                                                                action: () => {
                                                                    setUserEditModal({
                                                                        userId: value.userId,
                                                                        firstname: value.firstname,
                                                                        lastname: value.lastname,
                                                                        email: value.email,
                                                                        password: value.password,
                                                                        phone: value.phone,
                                                                        role: value.role[0],
                                                                    })
                                                                    setActiveTooltipId(null)
                                                                },
                                                            }
                                                    , {
                                                        title: value.disabled ? "Разблокировать" : "Заблокировать",
                                                        action: async () => {
                                                            await updateUser(value.userId, {
                                                                disabled: !value.disabled,
                                                            });
                                                            await fetchUsers()
                                                            setActiveTooltipId(null)
                                                        },
                                                    },
                                                    // Условное добавление действия "Удалить заблокированного"
                                                    ...(value.disabled
                                                        ? [
                                                            {
                                                                title: t("users.delete"),
                                                                action: async () => {

                                                                    setUserDelete(value)

                                                                    setActiveTooltipId(null);
                                                                },
                                                            },
                                                        ]
                                                        : []),
                                                ]}
                                                activeTooltipId={activeTooltipId}
                                                onTooltipToggle={handleTooltipToggle}
                                            />
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        )}
                    </table>
                </div>
            </div>



            {
                userData?.length > 0 && !isOpen2 && (
                    <Pagination
                        totalItems={userData?.length}
                        totalPages={Math.ceil(
                            userData?.length / pagination.pageSize,
                        )}
                        pagination={pagination}
                        setPagination={setPagination}
                    />
                )
            }

            {isLoading && <Loader />}

            {/* ТААК ТУТ МОДАЛКА РЕДАКТИРОВАНИЯ ПОЛЬЗОВАТЕЛЯ */}
            {userEditModal ? (
                <ModalComponent
                    isOpen={true}
                    onClose={() => {
                        setUserEditModal(null)
                    }}
                    headerContent={
                        <div className="flex justify-between">
                            <div className="flex items-center text-base text-gray-600 font-light gap-x-[10px] ">
                                <img src={"/icons/user-plus.svg"} className="w-[20px]" alt="icon" />
                                <div className="uppercase">{t("users.user_editing")}</div>
                            </div>
                            <button
                                type="button"
                                onClick={() => {
                                    setUserEditModal(null)
                                }}
                                aria-label="Close"
                                className="float-right cursor-pointer bg-none border-none"
                            >
                                &times;
                            </button>
                        </div>
                    }
                    content={
                        <>
                            <Formik
                                initialValues={userEditModal}
                                onSubmit={(formikValues) => submitEdit(formikValues)}
                                enableReinitialize={true}
                                validateOnBlur={true}
                                validateOnChange={true}
                                validationSchema={formValidationSchema(false)}
                            >
                                {(formik) => {
                                    return (
                                        <Form className=" w-full m-t-[20px]">
                                            <div className="flex flex-col bg-white my-5 p-5 pl-0 pr-0 pt-8 relative rounded-xl gap-[20px] overflow-visible">

                                                <div className={`flex gap-[20px] flex-wrap`}>
                                                    <div className={style.inputField1}>
                                                        <div className={style.labelAndButtonWrapper}>
                                                            <label className={style.inputLabel}>
                                                                {t("Имя")}
                                                            </label>
                                                            {formik.touched.firstname &&
                                                                formik.errors.firstname && (
                                                                    <div className={style.tooltipWrapper}>
                                                                        <FaExclamationCircle className={style.errorIcon} />
                                                                        <div className={style.tooltipText}>
                                                                            {typeof formik.errors.firstname ===
                                                                                "string"
                                                                                ? formik.errors.firstname
                                                                                : t(
                                                                                    "Ошибка",
                                                                                )}
                                                                        </div>
                                                                    </div>
                                                                )}
                                                        </div>
                                                        <Field
                                                            type="text"
                                                            name="firstname"
                                                            placeholder={t("Введите имя")}
                                                            className={style.placeholder}
                                                            onChange={(e: any) => {
                                                                formik.handleChange(e);
                                                                dispatch(setBlocker(true));
                                                                setIsFormChanged(true);
                                                            }}
                                                        />
                                                    </div>

                                                    <div className={style.inputField1}>
                                                        <div className={style.labelAndButtonWrapper}>
                                                            <label className={style.inputLabel}>
                                                                {t("Фамилия")}
                                                            </label>
                                                            {formik.touched.lastname &&
                                                                formik.errors.lastname && (
                                                                    <div className={style.tooltipWrapper}>
                                                                        <FaExclamationCircle className={style.errorIcon} />
                                                                        <div className={style.tooltipText}>
                                                                            {typeof formik.errors.lastname ===
                                                                                "string"
                                                                                ? formik.errors.lastname
                                                                                : t(
                                                                                    "Ошибка",
                                                                                )}
                                                                        </div>
                                                                    </div>
                                                                )}
                                                        </div>
                                                        <Field
                                                            type="text"
                                                            name="lastname"
                                                            placeholder={t("Введите фамилию")}
                                                            className={style.placeholder}
                                                            onChange={(e: any) => {
                                                                formik.handleChange(e);
                                                                dispatch(setBlocker(true));
                                                                setIsFormChanged(true);
                                                            }}
                                                        />
                                                    </div>

                                                    <div className={style.inputField1}>
                                                        <div className={style.labelAndButtonWrapper}>
                                                            <label className={style.inputLabel}>
                                                                {t("Логин")}
                                                            </label>
                                                            {formik.touched.email &&
                                                                formik.errors.email && (
                                                                    <div className={style.tooltipWrapper}>
                                                                        <FaExclamationCircle className={style.errorIcon} />
                                                                        <div className={style.tooltipText}>
                                                                            {typeof formik.errors.email ===
                                                                                "string"
                                                                                ? formik.errors.email
                                                                                : t(
                                                                                    "Ошибка",
                                                                                )}
                                                                        </div>
                                                                    </div>
                                                                )}
                                                        </div>
                                                        <Field
                                                            type="email"
                                                            name="email"
                                                            placeholder={t("Введите логин")}
                                                            className={style.placeholder}
                                                            onChange={(e: any) => {
                                                                formik.handleChange(e);
                                                                dispatch(setBlocker(true));
                                                                setIsFormChanged(true);
                                                            }}
                                                        />
                                                    </div>

                                                    <div className={style.inputField1}>
                                                        <div className={style.labelAndButtonWrapper}>
                                                            <label className={style.inputLabel}>
                                                                {t("Пароль")}
                                                            </label>
                                                            {formik.touched.password &&
                                                                formik.errors.password && (
                                                                    <div className={style.tooltipWrapper}>
                                                                        <FaExclamationCircle className={style.errorIcon} />
                                                                        <div className={style.tooltipText}>
                                                                            {typeof formik.errors.password ===
                                                                                "string"
                                                                                ? formik.errors.password
                                                                                : t(
                                                                                    "Ошибка",
                                                                                )}
                                                                        </div>
                                                                    </div>
                                                                )}
                                                        </div>
                                                        <div className="relative flex items-center">
                                                            <Field
                                                                type={showPassword ? "text" : "password"}  // Меняем тип на 'text', если показываем пароль
                                                                name="password"
                                                                placeholder="Введите пароль"
                                                                className="placeholder" // Ваш класс для стилей
                                                                onChange={(e: any) => {
                                                                    formik.handleChange(e);
                                                                    dispatch(setBlocker(true));
                                                                    setIsFormChanged(true);
                                                                }}
                                                            />

                                                            <button
                                                                type="button"
                                                                onClick={() => setShowPassword(prev => !prev)}
                                                                className="absolute right-2" // Позиционирование кнопки
                                                            >
                                                                {!showPassword ? (
                                                                    <img
                                                                        src="/icons/visible_eye.svg"
                                                                        alt="Скрыть пароль" // Добавлено свойство alt для доступности
                                                                        className="block h-[20px] w-[20px] duration-200 group-hover:brightness-200 group-hover:invert-1"
                                                                    />
                                                                ) : (
                                                                    <img
                                                                        src="/icons/dis_eye.svg"
                                                                        alt="Показать пароль"
                                                                        className="block h-[20px] w-[20px] duration-200 group-hover:brightness-200 group-hover:invert-1"
                                                                    />

                                                                )}
                                                            </button>
                                                        </div>
                                                    </div>

                                                    <div className={style.inputField1}>
                                                        <div className={style.labelAndButtonWrapper}>
                                                            <label className={style.inputLabel}>
                                                                {t("Телефон")}
                                                            </label>
                                                            {formik.touched.phone &&
                                                                formik.errors.phone && (
                                                                    <div className={style.tooltipWrapper}>
                                                                        <FaExclamationCircle className={style.errorIcon} />
                                                                        <div className={style.tooltipText}>
                                                                            {typeof formik.errors.phone ===
                                                                                "string"
                                                                                ? formik.errors.phone
                                                                                : t(
                                                                                    "notification_from_third_countries.error_customs_clearance_reg_date",
                                                                                )}
                                                                        </div>
                                                                    </div>
                                                                )}
                                                        </div>
                                                        <InputMask
                                                            mask="+7 (999) 999-99-99"
                                                            maskChar="_"
                                                            type="text"
                                                            name="phone"
                                                            placeholder={t("Введите телефон")}
                                                            className={style.placeholder}
                                                            value={formik.values.phone}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                    </div>

                                                    <div className={style.inputField1}>
                                                        <div className={style.labelAndButtonWrapper}>
                                                            <label className={style.inputLabel}>
                                                                {t("Роль")}
                                                            </label>
                                                            {formik.touched.role &&
                                                                formik.errors.role && (
                                                                    <div className={style.tooltipWrapper}>
                                                                        <FaExclamationCircle className={style.errorIcon} />
                                                                        <div className={style.tooltipText}>
                                                                            {typeof formik.errors.role ===
                                                                                "string"
                                                                                ? formik.errors.role
                                                                                : t(
                                                                                    "notification_from_third_countries.error_customs_clearance_reg_date",
                                                                                )}
                                                                        </div>
                                                                    </div>
                                                                )}
                                                        </div>
                                                        <Field
                                                            component={SelectCustomFormik}
                                                            name="role"
                                                            placeholder={t("Выберите роль")}
                                                            options={[
                                                                { value: 'ROLE_ADMIN', label: 'Админ' },
                                                                { value: 'ROLE_USER', label: 'Оператор' },
                                                            ]}
                                                            isMulti={false}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="flex justify-end gap-[10px]">
                                                <ModalButton
                                                    type="button"
                                                    onClick={() => {
                                                        dispatch(clearBlocker());
                                                        if (blocker && typeof blocker.proceed === "function") {
                                                            blocker.proceed();
                                                        } else {
                                                            console.error("Proceed function is not available.");
                                                        }
                                                        setUserEditModal(null)
                                                    }}
                                                >
                                                    {t("mainButtons.cancel")}
                                                </ModalButton>
                                                <ModalButton
                                                    type="submit"
                                                    color="green"
                                                    onClick={async () => {
                                                        dispatch(clearBlocker());
                                                        try {

                                                            if (blocker && typeof blocker.proceed === "function") {
                                                                blocker.proceed();
                                                            }
                                                        } catch (error) {
                                                            console.error("Error saving data:", error);
                                                        }
                                                    }}
                                                >
                                                    {t("mainButtons.save")}
                                                </ModalButton>
                                            </div>
                                        </Form>
                                    );
                                }}
                            </Formik>
                        </>
                    }
                    customContent={
                        <>
                        </>
                    }
                />
            ) : null}
            <AlertBox isOpen={alertOpen} setIsOpen={setAlertOpen} />
        </div>
    );
}

export default RegistrationUsers;
